import DraftsIcon from "@mui/icons-material/Drafts";
import ListReportDisPostOffice2 from "./List";

//params
export const REPORT_DISCOUNT_POST_OFFICE_2 = "districts/second-reference";

//permissions

export const resources = {
  isMenu: true,
  icon: <DraftsIcon />,
  name: REPORT_DISCOUNT_POST_OFFICE_2,
  title: "Справка - ОПС 2",
  list: <ListReportDisPostOffice2 />,
  permission: "editions",
};

//api url
